import platform from "../../../util/platform";
const create = (assessmentDirectory) => {
    return (params) => {
        const path = `/content/assessment-directory`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, assessmentDirectory);
    };
};
const update = (assessmentDirectory) => {
    return (params) => {
        const path = `/content/assessment-directory/directory/${assessmentDirectory.id}`;
        return platform.put(params, platform.getEdgeBaseUrl(), path, assessmentDirectory);
    };
};
const getById = (directoryId) => {
    return (params) => {
        const path = `/content/assessment-directory/directory/${directoryId}`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const getAll = () => {
    return (params) => {
        const path = `/content/assessment-directory`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const assessmentDirectory = {
    create,
    update,
    getById,
    getAll,
};
export default assessmentDirectory;
